import React from 'react';

import ImageModalTool from '../imageModalTool/ImageModalTool';

type ImageBackgroundToolProps = Omit<React.ComponentProps<typeof ImageModalTool>, 'mode'>;

/**
 * Opens the image modal background editor for a selected image.
 */
const ImageBackgroundTool: React.FC<ImageBackgroundToolProps> = (props) => (
    <ImageModalTool {...props} mode="background" />
);

export default ImageBackgroundTool;
